// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>67</span>&nbsp;&nbsp;Before I was afflicted I went astray,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but now I keep your word.<br> </p> </div></div>";
// Exports
module.exports = code;